export const iconList = [
    { title: "Arrow Down", value: "arrow-down" },
    { title: "Arrow Left", value: "arrow-left" },
    { title: "Arrow Right", value: "arrow-right" },
    { title: "Arrow Up Right", value: "arrow-up-right" },
    { title: "Bin", value: "bin" },
    { title: "Close", value: "close" },
    { title: "Edit", value: "edit" },
    { title: "Minus", value: "minus" },
    { title: "Plus", value: "plus" },
    { title: "Ruler", value: "ruler" },
    { title: "Shopping Bag", value: "shopping-bag" },
    { title: "View", value: "view" }
] as const
